<p
  class="text-explanation"
  [class.text-explanation--visible]="logoVisible()">
  Herzlich Willkommen bei YOUCA, der
  <b class="font-bold">Yo</b>ungsters <b class="font-bold">U</b>pbringing Mental Health Information and
  <b class="font-bold">C</b>ounselling <b class="font-bold">A</b>pp
</p>

<img class="image" [src]="imgUrl" [class.image--visible]="logoVisible()" alt="Logo">
